export default __webpack_public_path__ + "static/media/ROBO_PANTHER.f3f8ae5a.png";